// src/pages/ConfirmPage.js
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { withBase } from '../config/api'
import Overlay from '../components/Overlay'
import { useTranslation } from 'react-i18next'
import {
  modalPrimaryButtonStyle,
  modalSecondaryButtonStyle
} from '../styles/buttonStyles'
import {
  getMobileConfirmationUrl,
  isMobileDevice
} from '../utils/mobileConfirmationLink'

const ConfirmPage = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const didRun = useRef(false)
  const { t, i18n } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState({
    text: t('CONFIRMING'),
    type: 'info'
  })
  const [success, setSuccess] = useState(false)
  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  const closeModal = () => {
    navigate('/', { replace: true })
  }

  useEffect(() => {
    if (!token) {
      setMessage({ text: t('INVALID_LINK'), type: 'error' })
      return
    }

    if (didRun.current) return
    didRun.current = true

    const confirm = async () => {
      setIsLoading(true)

      try {
        const url = withBase(`/auth/confirm/${token}`)
        const res = await fetch(url, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
	    'Accept-Language': i18n.language
          }
        })
        const data = await res.json()

        if (res.ok) {
          setSuccess(true)
          setMessage({
            text: data.message || t('CONFIRMATION_SUCCESS'),
            type: 'success'
          })
        } else {
          setMessage({
            text: data.message || t('CONFIRMATION_FAILED'),
            type: 'error'
          })
        }
      } catch {
        setMessage({
          text: t('CONFIRMATION_FAILED'),
          type: 'error'
        })
      } finally {
        setIsLoading(false)
      }
    }

    // Universal/App Links otvoria aplikáciu priamo. Niektoré e-mailové
    // prehliadače ich však zachytia a načítajú web, preto tu skúsime aj
    // vlastnú schému aplikácie. Ak aplikácia nie je nainštalovaná, po krátkom
    // čase pokračujeme pôvodným webovým potvrdením.
if (isMobileDevice(window.navigator.userAgent)) {
  window.location.replace(getMobileConfirmationUrl(token))
  return
}

    confirm()
  }, [token, i18n.language, t])

  return (
    <>

      <Overlay open={isLoading} zIndex={4000} backdropOpacity={0.75} />

      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}
      >
        <div
          style={{
            background: '#ededed',
            padding: 20,
            border: '2px solid #107c6b',
            borderRadius: 12,
            boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
            width: 'clamp(320px, 30vw, 420px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <h3 style={{ fontSize: 28, margin: 0, marginBottom: 24 }}>
            {t('REGISTER_CONFIRMATION')}
          </h3>

          <div
            style={{
              width: '100%',
              boxSizing: 'border-box',
              marginBottom: 20,
              padding: '10px 12px',
              borderRadius: 8,
              border: `1px solid ${
                message.type === 'success'
                  ? '#1d7c3f'
                  : message.type === 'error'
                  ? '#aa2e2e'
                  : '#2d5a9e'
              }`,
              background:
                message.type === 'success'
                  ? '#d8f5df'
                  : message.type === 'error'
                  ? '#ffe1e1'
                  : '#e7f0ff',
              color:
                message.type === 'success'
                  ? '#135729'
                  : message.type === 'error'
                  ? '#7b1c1c'
                  : '#1d3f6e',
              fontSize: 14,
              textAlign: 'center'
            }}
          >
            {message.text}
          </div>

          <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
            <button
              type="button"
              disabled={isLoading}
              style={modalSecondaryButtonStyle(
                pressedBtn,
                'cancel',
                hoverBtn === 'cancel'
              )}
              onMouseEnter={() => setHoverBtn('cancel')}
              onMouseLeave={() => {
                setHoverBtn(null)
                setPressedBtn(null)
              }}
              onMouseDown={() => setPressedBtn('cancel')}
              onMouseUp={() => setPressedBtn(null)}
              onClick={closeModal}
            >
              {t('CLOSE')}
            </button>

            {success && (
              <button
                type="button"
                disabled={isLoading}
                style={modalPrimaryButtonStyle(
                  pressedBtn,
                  'login',
                  hoverBtn === 'login'
                )}
                onMouseEnter={() => setHoverBtn('login')}
                onMouseLeave={() => {
                  setHoverBtn(null)
                  setPressedBtn(null)
                }}
                onMouseDown={() => setPressedBtn('login')}
                onMouseUp={() => setPressedBtn(null)}
                onClick={() =>
                  navigate('/?showLogin=1', { replace: true })
                }
              >
                {t('LOGIN')}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfirmPage